export default "__VITE_ASSET__DOfjP9jy__"